/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Input, Form, Select, Radio } from "antd";
import UploadPreview from "../components/UploadPreview";
import MultiSelectFormItem from "./MultiSelectFormItem";
import SingleSelectRadioFormItem from "./SingleSelectRadioFormItem";
import DatePickerFormItem from "./DatePickerFormItem";
import propTypes from "prop-types";
import ComponentTitle from "../components/ComponentTitle";
import { generateRules } from "utils/helperFunctions";
import VoiceRecorder from "../VoiceRecorder";
import { setScroll } from "Redux/actions";

const fullNameRegex = new RegExp(
  "^[^<>'\"/;~^&*-_+={}|?.,`%()$#!@$0-9]*([a-zA-Z]+)?$"
);

const synmols = [
  "`",
  "~",
  "!",
  "@",
  "#",
  "$",
  "%",
  "^",
  "&",
  "*",
  "(",
  ")",
  "-",
  "_",
  "+",
  "=",
  "{",
  "}",
  ";",
  ":",
  "?",
  "/",
  ">",
  "<",
  ".",
  ",",
  "|",
  '"',
  "'",
  "\\",
  "[",
  "]",
];

const DynamicFormItem = ({ component, data: item, form }) => {
  const selectedLanguage = useSelector((state) => state.selectedLanguage);
  const dispatch = useDispatch();
  const error_messages = useSelector(
    (state) => state.widgetJSON.data.general_settings.error_messages
  );

  const [image, setImage] = useState({
    show: false,
    file: null,
  });

  const exceptions = ["age_range", "gender"];
  useEffect(() => {
    if (item.is_prefix) {
      if (component === "customer_data" && item.is_prefix && item.prefix) {
        form.setFieldsValue({
          customer_data: {
            [item.name]: item.prefix,
          },
        });
      }
    }

    if (component === "customer_data") {
      if (item.default) {
        form.setFieldsValue({
          customer_data: {
            [item.name]: item.default,
          },
        });
      }
    } else {
      if (item.default) {
        form.setFieldsValue({
          [item.name]: item.default,
        });
      }
    }
  }, []);

  const renderFormItem = (item) => {
    const radioStyle = {
      display: "block",
      height: "30px",
      lineHeight: "30px",
    };

    try {
      const { type } = item || {};
      const lowerType = isNaN(type) ? type.toLowerCase() : type;
      switch (lowerType) {
        case "select":
        case 5:
          if (item.select_design) {
            const { value = "" } = item.select_design;
            if (value === "dropdown") {
              return (
                <Select
                  onDropdownVisibleChange={(event) => {
                    dispatch(setScroll(!event))
                  }}
                  placeholder={item.placeholder[selectedLanguage]}
                  disabled={item.disable ? item.disable : false}
                  defaultValue={item.default}
                  getPopupContainer={(trigger) => trigger.parentNode}
                >
                  {item.select.map((selectItem, index) => (
                    <Select.Option key={index} value={selectItem.id}>
                      {selectItem.option[selectedLanguage]}
                    </Select.Option>
                  ))}
                </Select>
              );
            } else if (value === "radio_button") {
              return (
                <SingleSelectRadioFormItem
                  component={component}
                  item={item}
                  selectedLanguage={selectedLanguage}
                  form={form}
                />
              );
            }
          }
          return <div>No Select design</div>;
        case "text":
          return (
            <Input
              defaultValue={item.default}
              disabled={item.disable ? item.disable : false}
              placeholder={item.placeholder[selectedLanguage]}
              type={item.type}
              className="left-to-right-holder"
            />
          );
        case "email":
          return (
            <Input
              defaultValue={item.default}
              disabled={item.disable ? item.disable : false}
              placeholder={item.placeholder[selectedLanguage]}
              type={item.type}
              className="left-to-right-holder"
            />
          );
        case "radio":
          return (
            <Radio.Group>
              {item.select.map((item) => (
                <Radio style={radioStyle} value={item}>
                  {item}
                </Radio>
              ))}
            </Radio.Group>
          );
        case "number": //pattern="[0-9]*" inputMode="numeric"
          const attrs = {
            // pattern:"\d*",
            // pattern: "[0-9]",
            // inputMode: "numeric",
            defaultValue: item.default,
            disabled: item.disable ? item.disable : false,
            placeholder: item.placeholder[selectedLanguage],
            type: item.name === "phone_number" ? "tel" : "number",
            // type: "text",
            // type:'number'
            // onKeyDown: item.name !== 'phone_number' && onNumberKeyDown
          };

          if (item.name !== "phone_number") {
            attrs.onKeyDown = onNumberKeyDown;
          }

          return (
            <Input {...attrs} className="form-number left-to-right-holder" />
          );
        case "file":
          return (
            <UploadPreview
              image={image}
              setImage={setImage}
              component={component}
              form={form}
              item={item}
            />
          );
        case "image":
          return (
            <UploadPreview
              image={image}
              setImage={setImage}
              component={component}
              form={form}
              item={item}
            />
          );
        case "datetime":
          return (
            <DatePickerFormItem component={component} item={item} form={form} />
          );
        case "date":
          return (
            <DatePickerFormItem component={component} item={item} form={form} />
          );
        case "multi-select":
        case 6:
          return (
            <MultiSelectFormItem
              component={component}
              item={item}
              selectedLanguage={selectedLanguage}
              form={form}
            />
          );
        // case 'tel':
        //     return item.is_prefix ? <Input inputMode="numeric" pattern="[0-9]*" defaultValue={item.default} disabled={item.disable ? item.disable : false} placeholder={item.placeholder[selectedLanguage]} type="tel" /> : <Input inputMode="numeric" pattern="[0-9]*" disabled={item.disable ? item.disable : false} placeholder={item.placeholder[selectedLanguage]} type={item.type} />
        case "audio": {
          return (
            <VoiceRecorder {...{ component, item, selectedLanguage, form }} />
          );
        }
        default:
          <div>No item found</div>;
      }
    } catch (err) {
      console.log(err);
    }
  };

  const onNumberKeyDown = (e) => {
    const { key } = e;
    if (key.toLowerCase() === "e") {
      e.preventDefault();
    }
  };

  const getType = () => {
    let type = "string";
    let message = error_messages.required[selectedLanguage];

    switch (item.type) {
      case "email": {
        return {
          type: "email",
          message: error_messages.email_format[selectedLanguage],
        };
      }
      case "multi-select": {
        return {
          type: "array",
          message,
        };
      }
      case "select": {
        if (exceptions.includes(item.name)) {
          return {
            type: "string",
            message,
          };
        } else {
          return {
            // type: "array",
            // message,
          };
        }
      }
      case "tel": {
        return {
          type: "string",
          message,
        };
      }
      default: {
        return {
          type: "string",
          message,
        };
      }
    }
  };

  // const generatedRules = getType();

  return (
    <>
      {item?.componentType == "custom_field_feedback_component" && (
        <ComponentTitle component={item} />
      )}
      <Form.Item
        name={
          component === "customer_data" ? [component, item.name] : item.name
        }
        // style={{ paddingLeft: "20px", paddingRight: "20px" }}
        className="padding"
        rules={[
          ...generateRules({
            component: item,
            errors: error_messages,
            selectedLanguage: selectedLanguage,
          }),
          {
            validator: async (_, value) => {
              switch (item.name) {
                case "full_name": {
                  if (value) {
                    const splitedValue = value.trim().split(" ");
                    if (
                      splitedValue.some(
                        (text) =>
                          /\d/.test(text) ||
                          synmols.some((synbal) => text.includes(synbal))
                      )
                    ) {
                      return Promise.reject(
                        error_messages.full_name_format[selectedLanguage]
                      );
                    } else if (splitedValue.length < 2) {
                      return Promise.resolve();
                    }
                  }
                  break;
                }
                case "phone_number": {
                  if (new RegExp("^[+]?[0-9]+$").test(value)) {
                    if (item.prefix === value && !item.required) {
                      return Promise.resolve();
                    } else if (!(value.length > 9 && value.length < 15)) {
                      return Promise.reject(
                        error_messages.phone_format[selectedLanguage]
                      );
                    }
                  }
                  break;
                }
                default: {
                  return Promise.resolve();
                }
              }
            },
          },
        ]}
      >
        {renderFormItem(item)}
      </Form.Item>
    </>
  );
};

//@ts-ignore
DynamicFormItem.propTypes = {
  component: propTypes.string,
};

//@ts-ignore
DynamicFormItem.defaultProps = {
  component: "custom_field_feedback_component",
};

export default DynamicFormItem;
